// @ts-strict-ignore
import styled from 'styled-components';
import TipCallout from '../TipCallout/TipCallout';
import TimeframeNumberInput from './TimeframeNumberInput';
import { StyledRuleClause } from '../NodeEditorDrawer/ThresholdsTab/RuleBuilderContainer/Rule/RuleTemplate/styles';

export const StyledTipCallout = styled(TipCallout)`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
`;

export const StyledAggregationCriteriaContainer = styled.div`
  flex: 6;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--cl-space-2);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  align-self: flex-start;
`;

export const StyledAggregationSubEditorLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cl-space-2);
  width: 100%;
`;

export const StyledAggregationSubEditorRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--cl-space-3);
  width: 100%;
`;

export const StyledAggregationSubEditorActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--cl-space-2);
`;

export const StyledAggregationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--cl-space-2);
  width: 100%;
`;

export const StyledAggregationCriteriaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--cl-space-1);
  width: 100%;
`;

export const StyledAggregationNameDescriptionContainer = styled.div`
  flex: 4;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--cl-space-2);
  padding: var(--cl-space-3);
  background-color: var(--cl-gray-100);
  border-radius: var(--cl-radius-2);
  box-sizing: border-box;
`;

export const StyledAggregationSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  height: fit-content;
  margin: 0.5px var(--cl-space-1) 0 0;
  flex-shrink: 0;
  flex-wrap: wrap;

  > div {
    display: flex;
    align-items: center;
  }
`;

/** Static clause text in aggregation criteria (e.g. "of", "Scope:", "to"). Built on StyledRuleClause; uses containerType for alignment. */
export const StyledAggregationClause = styled(StyledRuleClause).attrs({
  isEmptyPreviewOutcome: false,
})``;

/** Inline whole-integer input for timeframe from/to. Borderless, invisible background, bold; hover matches AggregationSelect/MultiSelect (naked: yellow-200). */
export const StyledTimeframeNumberInput = styled(TimeframeNumberInput)`
  &[data-timeframe-number-input] {
    display: inline-block;
    width: fit-content;
    margin-top: 0;
    border: none;
    background: transparent;
    border-radius: var(--cl-radius-1);
  }
  &[data-timeframe-number-input]:hover {
    background-color: var(--cl-yellow-200);
  }
  &[data-timeframe-number-input] span {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    outline: none;
  }
  &[data-timeframe-number-input] > span {
    display: inline-block;
    width: fit-content;
    margin-top: 0 !important;
    border-radius: var(--cl-radius-1);
  }
  &[data-timeframe-number-input] > span > span:first-child {
    display: none;
  }
  &[data-timeframe-number-input] input {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    outline: none;
    font-weight: bold;
    font-size: var(--cl-font-size-2);
    line-height: var(--cl-line-height-3);
    font-family: var(--cl-font-family-mono);
    color: var(--green-green-550, #3A795F);
    padding: 0 var(--cl-space-1);
    min-width: 1ch;
    max-width: none;
    field-sizing: content;
  }
  &[data-timeframe-number-input] input:focus {
    outline: none;
  }
  &[data-timeframe-number-input] input:focus-visible {
    outline: 2px solid var(--cl-border-focus-ring);
    outline-offset: 2px;
  }
`;

